import { Component } from '@theme/component';

/**
 * Corrects the post-submit scroll position for the email signup form.
 *
 * Shopify's native customer-form redirect appends `#<form id>` to the URL,
 * and the browser jumps straight to the `<form>` element on load. The
 * heading/intro copy above this form is rendered by a separate sibling
 * block, so that native jump lands the viewport past it. This nudges the
 * scroll back up to the top of the enclosing section once the page has
 * settled, so the heading is visible again.
 *
 * @extends {Component}
 */
export class EmailSignup extends Component {
  connectedCallback() {
    super.connectedCallback();

    const form = this.querySelector('form');
    if (!form?.id || window.location.hash !== `#${form.id}`) return;

    const section = this.closest('.section') ?? this;
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('email-signup-component')) {
  customElements.define('email-signup-component', EmailSignup);
}
